import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";
import { MyInput } from "../../atoms";
import "../../molecules/ModalAddExcoPUK/ModalAddExcoPUK.css";

/**
 * Modal Tambah Komisaris RT/RW
 * Location fields (Provinsi, Kab/Kota, Kecamatan, Kelurahan) are auto-filled
 * from the parent detail data (dataDetailExcoPusat.data.alamat).
 * User only needs to input RT, RW, and Kode Pos.
 */
const ModalAddRTRW = ({ open, onClose, onSubmit }) => {
  const dataDetailExcoPusat = useSelector(
    (state) => state.excopusat.dataDetailExcoPusat,
  );

  const alamat = dataDetailExcoPusat?.data?.alamat || {};

  const [formData, setFormData] = useState({
    rtrw: "",
  });

  const [errors, setErrors] = useState({});

  const handleSubmit = () => {
    const newErrors = {};
    if (!formData.rtrw.trim())
      newErrors.rtrw = "RTRW/Dusun/Kampung wajib diisi";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const payload = {
      id_tingkat_exco: 6,
      id_provinsi: alamat.id_provinsi,
      id_kabkot: alamat.id_kabkot,
      id_kecamatan: alamat.id_kecamatan,
      id_kelurahan: alamat.id_kelurahan,
      tingkat_rt_rw: formData.rtrw.trim(),
    };

    onSubmit(payload);
    onClose();
  };

  useEffect(() => {
    if (!open) {
      setFormData({ rtrw: "" });
      setErrors({});
    }
  }, [open]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => {
      const newErrors = { ...prev };
      if (!value || !value.trim()) {
        newErrors[name] = "RTRW/Dusun/Kampung wajib diisi";
      } else {
        delete newErrors[name];
      }
      return newErrors;
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: { borderRadius: 12 },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700, fontSize: "20px" }}>
          Tambah Komisaris RT/RW
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <div
          className="modal-body"
          style={{
            margin: 0,
            padding: "8px 0",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          {/* Provinsi - Read Only */}
          <TextField
            label="Provinsi"
            value={alamat.nama_provinsi || "-"}
            InputProps={{ readOnly: true }}
            variant="outlined"
            size="small"
            fullWidth
            disabled
          />

          {/* Kab/Kota - Read Only */}
          <TextField
            label="Kab/Kota"
            value={alamat.nama_kab_kot || "-"}
            InputProps={{ readOnly: true }}
            variant="outlined"
            size="small"
            fullWidth
            disabled
          />

          {/* Kecamatan - Read Only */}
          <TextField
            label="Kecamatan"
            value={alamat.nama_kecamatan || "-"}
            InputProps={{ readOnly: true }}
            variant="outlined"
            size="small"
            fullWidth
            disabled
          />

          {/* Kelurahan/Desa - Read Only */}
          <TextField
            label="Kelurahan/Desa"
            value={alamat.nama_kel_desa || alamat.nama_kelurahan || "-"}
            InputProps={{ readOnly: true }}
            variant="outlined"
            size="small"
            fullWidth
            disabled
          />

          {/* RTRW/Dusun/Kampung - Single field */}
          <div>
            <MyInput
              label="RTRW/Dusun/Kampung"
              name="rtrw"
              value={formData.rtrw}
              onChange={(e) => handleChange("rtrw", e.target.value)}
              error={!!errors.rtrw}
              helperText={errors.rtrw}
            />
            <Typography
              variant="caption"
              sx={{ color: "#888", mt: 0.5, display: "block" }}
            >
              Contoh: RT 01/RW 02, Dusun Mawar, Kampung Sejahtera
            </Typography>
          </div>
        </div>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 1 }}>
        <div className="modal-footer" style={{ width: "100%", margin: 0 }}>
          <button className="btn-cancel" onClick={onClose}>
            Batal
          </button>
          <button className="btn-submit" onClick={handleSubmit}>
            <AddIcon fontSize="small" />
            Tambahkan
          </button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default ModalAddRTRW;
